// @flow
const url = require('url');

function ensureTrailingSlash(path: string): string {
  if (path.substr(-1) !== '/') {
    return path + '/';
  }

  return path;
}

function ensureLeadingSlash(path: string): string {
  if (path.charAt(0) !== '/') {
    return '/' + path;
  }

  return path;
}

function stripTrailingSlash(path: string): string {
  if (path.substr(-1) === '/') {
    return path.substr(0, path.length - 1);
  }

  return path;
}

const HOST = ensureTrailingSlash(
  process.env.REACT_APP_MODERATION_SERVICE || ''
);

export default function getEndpointUrl(pathname: string): string {
  return url.resolve(HOST, stripTrailingSlash(ensureLeadingSlash(pathname)));
}

if (process.env.NODE_ENV === 'test') {
  Object.assign(getEndpointUrl, {
    ensureTrailingSlash,
  });
}



// WEBPACK FOOTER //
// ./src/api/getEndpointUrl.js